import { render, staticRenderFns } from "./SignUpFormStep2.vue?vue&type=template&id=55d75b53&"
import script from "./SignUpFormStep2.vue?vue&type=script&lang=js&"
export * from "./SignUpFormStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports